// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + (chunkId === 2076 ? "common" : chunkId) + "." + {"1036":"59d3f891","2076":"7745934a","4764":"675d2aab","8734":"5d0931f8"}[chunkId] + ".chunk.css";
};